var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",style:({
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingLeft: _vm.column.colId === '__meta__' ? '5px' : '10px'
  }),attrs:{"data-row-id":_vm.rowIndex}})}
var staticRenderFns = []
export { render, staticRenderFns }